import React, { useState, useEffect } from "react";
import contacts from "./data";
import "./contact.css";

const InternshipContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    lastName: "",
    email: "",
    mobile: "",
    program: "",
  });
  const [resume, setResume] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [courses, setCourses] = useState([]);

  // Use environment variable for API URL
  const API_URL = (process.env.REACT_APP_API_URL || "http://localhost:5000").replace(/\/$/, "");

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const res = await fetch(`${API_URL}/api/courses`);
        if (res.ok) {
          const json = await res.json();
          if (json.success && Array.isArray(json.data)) {
            setCourses(json.data);
          }
        }
      } catch (err) {
        console.error("Failed to fetch courses for form:", err);
      }
    };
    fetchCourses();
  }, [API_URL]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/pdf") {
      if (file.size <= 5 * 1024 * 1024) {
        // 5MB
        setResume(file);
        setMessage("");
      } else {
        setMessage("File size must be less than 5MB");
        e.target.value = "";
      }
    } else {
      setMessage("Please upload a PDF file");
      e.target.value = "";
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const formDataToSend = new FormData();

      Object.keys(formData).forEach((key) => {
        formDataToSend.append(key, formData[key]);
      });

      if (resume) {
        formDataToSend.append("resume", resume);
      }

      const response = await fetch(`${API_URL}/api/contact/internship`, {
        method: "POST",
        body: formDataToSend,
      });

      const data = await response.json();

      if (data.success) {
        setMessage("✅ Application submitted successfully!");
        // Reset form
        setFormData({
          name: "",
          lastName: "",
          email: "",
          mobile: "",
          program: "",
        });
        setResume(null);
        document.getElementById("resume-input").value = "";
      } else {
        setMessage("❌ " + data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      setMessage("❌ Failed to submit form. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact">
      <h2>Data Science Training and Internship - CP</h2>
      <p className="para">Submit your application along with your resume!</p>

      <div className="form__container">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">First Name:</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="lastName">Last Name:</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="mobile">Mobile Number:</label>
            <input
              type="tel"
              id="mobile"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="program">Program / Course:</label>
            <select
              id="program"
              name="program"
              value={formData.program}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #ccc',
                borderRadius: '5px',
                background: '#fff',
                color: '#333',
                fontFamily: 'inherit',
                fontSize: '0.95rem',
                outline: 'none',
                cursor: 'pointer'
              }}
            >
              <option value="" disabled style={{ color: '#999' }}>Select a program...</option>
              {courses.length > 0 ? (
                courses.map((course) => (
                  <option key={course._id} value={course.title} style={{ color: '#333' }}>
                    {course.title}
                  </option>
                ))
              ) : (
                <>
                  <option value="Data Science" style={{ color: '#333' }}>Data Science</option>
                  <option value="Data Analytics" style={{ color: '#333' }}>Data Analytics</option>
                  <option value="Data Engineering" style={{ color: '#333' }}>Data Engineering</option>
                </>
              )}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="resume-input">
              Upload Resume (PDF only, max 5MB):
            </label>
            <input
              id="resume-input"
              type="file"
              accept=".pdf,application/pdf"
              onChange={handleFileChange}
              required
            />
            {resume && (
              <p
                className="resume-name"
                style={{ marginTop: "10px", color: "#08a3c2" }}
              >
                📎 {resume.name}
              </p>
            )}
          </div>

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? "Submitting..." : "Submit Application"}
          </button>
        </form>

        {message && (
          <p
            style={{
              marginTop: "20px",
              padding: "15px",
              borderRadius: "5px",
              backgroundColor: message.includes("✅") ? "#d4edda" : "#f8d7da",
              color: message.includes("✅") ? "#155724" : "#721c24",
              textAlign: "center",
            }}
          >
            {message}
          </p>
        )}
      </div>
    </section>
  );
};

export default InternshipContactForm;
